import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { fromSecondsToMilliseconds } from '@cbridge-utils/shared-helpers';
import { SymbolAction } from '../symbol.action';

type IDependencies = IClientApiDependencySegment;

export const bulkUpdateSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.bulkUpdate.started),
  mergeMap((params) => {
    return dependencies.api.bulkUpdateCoreSymbols({
      symbolIds: params.symbolIds,
      symbolGroup: params.symbolGroup,
      scheduleId: params.scheduleId,
      pricingTimeout: params.pricingTimeout !== undefined
        ? fromSecondsToMilliseconds(params.pricingTimeout)
        : undefined,
    }).pipe(
      mergeMap(() => {
        return [
          SymbolAction.bulkUpdate.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolAction.bulkUpdate.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
